module.exports = __webpack_public_path__ + "static/media/digital-styling-product.ef0639b1.png";